<template>
<div>

	<div v-if='!mallShow'>
		<div class="big big9 " v-if="active_show==999">
			<div class="login login9">
				<img src="../../assets/img/login11.png" alt="" />
				<div class="names">
					<span class="tou">券号：</span>
					<input @keyup.13=login() type=""  name="" id="" v-model="number" />
				</div>
				<div class="password">
					<span class="tou">密码：</span>
					<input @keyup.13=login() type="password"  name="" id="" v-model="password" />
				</div>
				<div class="butlogin" @click="login" style="display: flex;justify-content: space-around;">
					<div class="buttonm" >立即兑换</div>
				</div>

				<div class="login-notice">
					<el-checkbox v-model="checkedNotice"></el-checkbox>
					<div>
						<span>登录即同意特享专区</span>
						<span class="notice" @click="onClickPrivacyShow(1)">《使用协议》</span>
						<span class="notice" @click="onClickPrivacyShow(2)">《隐私协议》</span>
					</div>
				</div>
			</div>
		</div>
		<div class="big big10 " v-if="active_show==2058">
			<div class="login login9">
				<img src="../../assets/img/login11.png" alt="">
				<div class="names">
					<span class="tou">券号：</span>
					<input @keyup.13=login() type=""  name="" id="" v-model="number" />
				</div>
				<div class="password">
					<span class="tou">密码：</span>
					<input @keyup.13=login() type="password"  name="" id="" v-model="password" />
				</div>
				<div class="butlogin" @click="login" style="display: flex;justify-content: space-around;">
					<div class="buttonm" >立即兑换</div>
				</div>

        <div class="login-notice">
					<el-checkbox v-model="checkedNotice"></el-checkbox>
					<div>
						<span>登录即同意特享专区</span>
						<span class="notice" @click="onClickPrivacyShow(1)">《使用协议》</span>
						<span class="notice" @click="onClickPrivacyShow(2)">《隐私协议》</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else class="jz_b">
		<img src="../../assets/img/timgs.gif" alt="" />
	</div>

	<div class="tc_box" v-if='deviceIdShow'>
		<p></p>
		<div class="img_box">
			<div style="text-align:center">
				<img style="position:absolute;top:-45px;width:80px;height:94px;left:0;right:0;margin:auto" src="../../assets/img/yz_t_icon.png" alt="" />
				<div style="font-size:24px;font-weight:600 ;margin-top:86px;">请进行安全验证</div>
				<div style="font-size:14px;padding:0 30px;line-height:28px;margin-top:20px;">由于您在新设备/浏览器上登录，为了您的账号安全，请进行安全验证。
	平台将验证您当前登录券号最近一笔订单的收货手机号。</div>
				<div style="font-size:16px;font-weight:600 ;margin-top:48px;"><span>请输入收货手机号中间4位：</span><span>{{starMobile}}</span></div>
				<div style="position:relative;margin-top:16px;" :class="centerMobile.length==4?'inpo_big':''">
					<mobiles @finish='finish' ref="yzMobiles"></mobiles>
					
				</div>
				<div class="button_b" @click="binddeviceVerifyMobile">
					确 定
				</div>
			</div>
		</div>
	</div>

	<div class="tc_box" v-if='leftTimesShow'>
		<p></p>
		<div class="img_box" style="height:316px">
			<div style="text-align:center">
				<img style="position:absolute;top:-40px;width:80px;height:80px;left:0;right:0;margin:auto" src="../../assets/img/shibai.png" alt="" />
				<div style="font-size:24px;font-weight:600 ;margin-top:86px;">验证失败</div>
				<div style="font-size:14px;padding:0 30px;line-height:28px;margin-top:20px;">输入的手机号码错误，还有{{leftTimes}}次验证机会</div>
				<div class="button_b" @click="deviceIdShow=true,leftTimesShow=false">
					确 定
				</div>
			</div>
		</div>
	</div>

  <div class="tc_box" v-if="sxBoxshow">
    <p></p>
    <div class="img_box" style="height:348px">
			<div style="text-align:center">
				<img style="position:absolute;top:-40px;width:80px;height:80px;left:0;right:0;margin:auto" src="../../assets/img/shibai.png" alt="" />
				<div style="font-size:24px;font-weight:600 ;margin-top:86px;">验证次数已达上限</div>
				<div style="font-size:14px;padding:0 30px;line-height:28px;margin-top:20px;">您可以24小时后再次尝试</div>
				<div style="font-size:14px;padding:0 30px;line-height:28px;margin-top:20px;font-weight:600 ;">联系平台客服400-007-6666</div>
				<div class="button_b" @click="deviceIdShow=false,leftTimesShow=false,sxBoxshow=false">
					确 定
				</div>
			</div>
    </div>
  </div>

	<PrivacyPolicyDialog :show="privacyShow" :type="privacyType" @handleClose="handleCloseDialog" @handleConfirm="handleConfirmDialog"></PrivacyPolicyDialog>

</div>

	
</template>

<script>
import { Message, Loading } from "element-ui";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import mobiles from "@/components/mobile_yam.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import $ from "jquery";
import md5 from "js-md5";
import PrivacyPolicyDialog from "@/components/privacyPolicy/privacyPolicy.vue";
export default {
  name: "index",
  data() {
    var vm = this;
    return {
      number: this.$route.query.cardNo ? this.$route.query.cardNo : "",
      password: this.$route.query.cardPwd
        ? decodeURIComponent(this.$route.query.cardPwd)
        : "",
      active_show: 999,
      mallShow: false,
      DeviceId: "",
      starMobile: "",
      deviceIdShow: false,
      sxBoxshow: false,
      topMobile: "", //前3位
      deviceIdMobile: "", //后4位
      centerMobile: "",
      leftTimes: "null",
      leftTimesShow: false,
      checkedNotice: false, // 登录须知
      privacyShow: false,
      privacyType: 1, // 1 使用协议 ，2隐私协议
    };
  },
  components: {
    mobiles,
    PrivacyPolicyDialog,
  },
  computed: {},
  created() {
    console.log(13);

    var url = window.location.href;
    var num = window.location.href.indexOf("#");
    var urls = url.substr(num + 1);
    console.log(urls);
    console.log(urls.toLowerCase());
    if (urls.toLowerCase().indexOf("#") != -1) {
      var num1 = urls.indexOf("#");
      var urls1 = urls.substr(num1 + 1);
      this.active_show = urls1;
      sessionStorage.setItem("active_show", urls1);
      console.log(urls1);
      if (this.active_show == 2058) {
        document.title = "福利兑换页";
      }
    } else {
      var active = sessionStorage.getItem("active_show");
      if (active) {
        this.active_show = active;
        if (this.active_show == 2058) {
          document.title = "福利兑换页";
        }
      }
    }
    console.log(this.number, this.password);
    console.log(this.$cookies.get("login_user"));
    if (this.$route.query.cardNo) {
      this.mallShow = true;
      this.malllogin();
    }
    this.getDeviceId(); //获取设备标识
  },
  mounted() {
    let isRead = window.localStorage.getItem("privacy_show_flag");
    isRead && (this.checkedNotice = true);
  },
  methods: {
    finish(e) {
      console.log(e);
      this.centerMobile = e;
    },
    getDeviceId() {
      //获取设备标识
      var that = this;
      let DeviceId = localStorage.getItem("DeviceId");
      if (DeviceId) {
        this.DeviceId = DeviceId;
      } else {
        let fpPromise = FingerprintJS.load();
        fpPromise.then((fp) => fp.get()).then((result) => {
          console.log(result.visitorId);
          that.DeviceId = result.visitorId;
        });
      }
    },
    binddeviceVerifyInfo() {
      //获取认证信息
      let data = {
        cardNo: this.number,
      };
      this.$server.deviceVerifyInfo(data).then((res) => {
        console.log("获取认证信息", res);
        if (res.code == 0) {
          let mobile = res.data.default.mobile;
          this.starMobile = mobile;
          this.deviceIdMobile = mobile.substring(mobile.length - 4);
          this.topMobile = mobile.substring(0, 3);
          console.log(this.deviceIdMobile, "-----", this.topMobile);
        }
      });
    },
    binddeviceVerifyMobile() {
      //验证用户手机号
      if (!this.centerMobile || this.centerMobile.length != 4) {
        this.$message({
          message: "请输入手机号中间4位",
          type: "warning",
        });
        return;
      }
      let data = {
        cardNo: this.number,
        cardPwd: this.password,
        clientPlatform: 2,
        deviceId: this.DeviceId,
        mobile: this.topMobile + this.centerMobile + this.deviceIdMobile,
      };
      this.$server.deviceVerifyMobile(data).then((res) => {
        console.log("验证用户手机号", res);
        if (res.code == 0) {
          this.$message({
            message: "验证成功",
            type: "success",
          });
          this.$store.state.validTimes = res.data.validTimes;
          this.$store.state.show_id_two = "";
          this.$store.state.show_id = "";
          sessionStorage.setItem("img_show", 2);
          sessionStorage.setItem("user", JSON.stringify(res.data));
          var cart_list = localStorage.getItem("cart_list");
          var list = cart_list ? JSON.parse(cart_list) : [];
          if (list.length > 0) {
            if (list[0].festivalid != res.data.festival.id) {
              localStorage.setItem("cart_list", []);
            }
          }
          this.getUser(res.data);
        } else {
          this.$refs.yzMobiles.reset();
          this.leftTimes =
            res.data && res.data.default ? res.data.default.leftTimes : "";
          this.deviceIdShow = false;
          this.centerMobile = "";
          if (res.code == 30001) {
            console.log(res.data.default.leftTimes == 0);
            if (res.data.default.leftTimes == 0) {
              this.sxBoxshow = true;
            } else {
              this.leftTimesShow = true;
            }
            return;
          }
          if (res.code == 30002) {
            this.sxBoxshow = true;
            return;
          }
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    malllogin() {
      var login_user = this.$cookies.get("login_user");
      var tokens = decodeURIComponent(this.$route.query.token);
      if (this.number) {
        var data = {
          cardNo: this.number,
          clientPlatform: 2,
          // cardPwd:this.password,
          token: login_user && login_user.token ? login_user.token : tokens,
        };
        this.$server.loginByFestivalCardInMall(data).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "登录成功",
              type: "success",
            });
            this.$store.state.validTimes = res.data.validTimes;
            this.$store.state.show_id_two = "";
            this.$store.state.show_id = "";
            sessionStorage.setItem("img_show", 2);
            sessionStorage.setItem("user", JSON.stringify(res.data));
            var cart_list = localStorage.getItem("cart_list");
            var list = cart_list ? JSON.parse(cart_list) : [];
            if (list.length > 0) {
              if (list[0].festivalid != res.data.festival.id) {
                localStorage.setItem("cart_list", []);
              }
            }
            this.getUser(res.data);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
            this.mallShow = false;
          }
        });
      } else {
        this.mallShow = false;
        this.$message({
          message: "卡劵号不能为空",
          type: "warning",
        });
      }
    },
    getUser(user) {
      var headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: user.token,
      };
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log(res);
        if (res.code == 0) {
          user.cardDate = res.data.default.cardDate;
          this.$store.state.validTimes = res.data.default.validTimes;
          this.$store.state.balance = res.data.default.balance;
          console.log("020202", user);
          sessionStorage.setItem("user", JSON.stringify(user));
        }
        this.$router.replace({
          path: "/",
        });
        this.mallShow = false;
      });
    },
    login() {
      if (this.number && this.password) {
        // var password = md5(this.password).toUpperCase()
        let isRead = window.localStorage.getItem("privacy_show_flag");

        if (!isRead) {
          this.onClickPrivacyShow(2);
          return;
        }

        if (!this.checkedNotice) {
          this.onClickPrivacyShow(1);
          return;
        }

        var data = {
          cardNo: this.number,
          cardPwd: this.password,
          clientPlatform: 2,
          deviceId: this.DeviceId,
        };
        this.$server.login(data).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: "登录成功",
              type: "success",
            });
            this.$store.state.validTimes = res.data.validTimes;
            this.$store.state.show_id_two = "";
            this.$store.state.show_id = "";
            sessionStorage.setItem("img_show", 2);
            sessionStorage.setItem("user", JSON.stringify(res.data));
            var cart_list = localStorage.getItem("cart_list");
            var list = cart_list ? JSON.parse(cart_list) : [];
            if (list.length > 0) {
              if (list[0].festivalid != res.data.festival.id) {
                localStorage.setItem("cart_list", []);
              }
            }
            this.getUser(res.data);
          } else {
            if (res.code == 30000) {
              this.binddeviceVerifyInfo();
              this.deviceIdShow = true;
              return;
            }
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      } else {
        this.$message({
          message: "卡劵或密码不能为空",
          type: "warning",
        });
      }
    },
    onClickPrivacyShow(type) {
      this.privacyType = type;
      this.privacyShow = true;
    },
    handleCloseDialog() {
      this.privacyShow = false;
      this.checkedNotice = false;
      window.localStorage.removeItem('privacy_show_flag');
    },
    handleConfirmDialog() {
      this.privacyShow = false;
      this.checkedNotice = true;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.fgx_big {
  display: flex;
  width: 420px;
  height: 60px;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  position: relative;
  border: 1px solid #cccccc;
  border-radius: 10px;
  z-index: 10;
}
.fgx {
  // position: absolute;
  height: 60px;
  width: 25%;
  border-right: 1px solid #cccccc;
}

.inpo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding-left: 50px;
  // opacity:0;
  z-index: 11;
  // text-align: center;
  border-radius: 10px;
  border: 1px solid #cccccc;
}
.text_num {
  width: 420px;
  height: 60px;
  border-radius: 10px;
  margin: 0 auto;
  border: 1px solid #cccccc;
  position: absolute;
  top: 0;
  left: 50px;
}
.button_b {
  width: 420px;
  height: 64px;
  background: #ff5c4d;
  border-radius: 40px;
  line-height: 64px;
  color: white;
  text-align: center;
  font-size: 20px;
  margin: 32px auto;
}
.tc_box {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.tc_box p {
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
}
.tc_box .img_box {
  position: absolute;
  width: 520px;
  height: 508px;
  background: #ffffff;
  border-radius: 20px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.tc_box .img1 {
  height: 60vh;
  // width:440px;
}
.tc_box .img2 {
  height: 40px;
  width: 40px;
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  margin: auto;
}
.yz_box {
  display: flex;
  align-items: center;
  border: 1px solid;
  width: 150px;
  padding: 5px 10px;
}
.login9 {
  left: 10% !important;
}
.big {
  height: 100vh;
  width: 100vw;
  position: relative;
}
.big9 {
  background: url(../../assets/img/banner10.png) no-repeat center center;
  background-size: 100%;
}
.big10 {
  background: url(../../assets/img/dz_banner.png) no-repeat center center;
  background-size: 100%;
}
// .big1{
// 	background:url(../../assets/img/banner0.png) no-repeat center center;
// 	background-size: cover;
// }
// .big2{
// 	background:url(../../assets/img/banner2.png) no-repeat center center;
// 	background-size: cover;
// }
// .big3{
// 	background:url(../../assets/img/banner3.png) no-repeat center center;
// 	background-size: cover;
// }
// .big4{
// 	background:url(../../assets/img/banner4.png) no-repeat center center;
// 	background-size: cover;
// }
// .big5{
// 	background:url(../../assets/img/banner5.png) no-repeat center center;
// 	background-size: cover;
// }
.login {
  min-height: 300px;
  width: 385px;
  background: white;
  border-radius: 10px;
  padding: 28px 30px;
}
.login {
  position: absolute;
  top: 33%;
  right: 55%;
}

.names {
  height: 46px;
  background: #9b1925;
  border-radius: 10px;
  margin-top: 21px;
  margin-bottom: 16px;
  line-height: 46px;
  padding: 0 12px;
}
.password {
  height: 46px;
  background: #9b1925;
  border-radius: 10px;
  padding: 0 12px;
  line-height: 46px;
}
.login9 .names {
  background: #f1bd59 !important;
}
.login9 .password {
  background: #f1bd59 !important;
}

.butlogin {
  text-align: center;
  margin-top: 18px;
  cursor: pointer;
}
.butlogin .buttonm {
  width: 217px;
  height: 47px;
  background: #f1bd59;
  border-radius: 10px;
  line-height: 47px;
  text-align: center;
  color: white;
  font-size: 26px;
}
.tou {
  width: 62px;
  height: 20px;
  font-size: 20px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
}
.login input {
  border: none;
  outline: none;
  background-color: #9b1925 !important;
  background: #9b1925 !important;
  color: white !important;
  width: 230px;
  // font-size:20px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.login9 input {
  background-color: #f1bd59 !important;
  background: #f1bd59 !important;
}
.jz_b {
  position: relative;
  top: 300px;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100px;
  height: 100px;
}
.jz_b img {
  width: 100px;
  height: 100px;
}

.login-notice {
  display: flex;
  align-items: center;
  padding-top: 36px;

  > div {
    display: flex;
    align-items: center;
    padding-left: 6px;
    cursor: pointer;
  }

  .notice {
    color: #f1bd59;
  }
}
</style>
